import {NgModule} from '@angular/core';
import {CalendarComponent} from './components/calendar/calendar.component';
import {DayViewComponent} from './components/day-view/day-view.component';
import {FullcalendarViewComponent} from './components/fullcalendar-view/fullcalendar-view.component';
import {NewAppointmentComponent} from './components/new-appointment/new-appointment.component';
import {EditAppointmentComponent} from './components/edit-appointment/edit-appointment.component';
import {AppointmentEditFormComponent} from './components/appointment-edit-form/appointment-edit-form.component';
import {AppointmentDetailDialogComponent} from './components/appointment-detail-dialog/appointment-detail-dialog.component';
import {AppointmentNotificationLogComponent} from './components/appointment-notification-log/appointment-notification-log.component';
import {AppointmentPatientMetaDataFormComponent} from './components/appointment-patient-meta-data-form/appointment-patient-meta-data-form.component';

/**
 * NgModule wrapper for the xmedical-calendar library.
 * Import this module in NgModule-based apps (e.g. xmedical-app) to use calendar components.
 *
 * Consumers must also provide:
 *  - CALENDAR_DATA_PROVIDER (CalendarDataProvider implementation)
 *  - CALENDAR_ACTION_HANDLER (CalendarActionHandler implementation)
 */
@NgModule({
  imports: [
    CalendarComponent,
    DayViewComponent,
    FullcalendarViewComponent,
    NewAppointmentComponent,
    EditAppointmentComponent,
    AppointmentEditFormComponent,
    AppointmentDetailDialogComponent,
    AppointmentNotificationLogComponent,
    AppointmentPatientMetaDataFormComponent,
  ],
  exports: [
    CalendarComponent,
    DayViewComponent,
    FullcalendarViewComponent,
    NewAppointmentComponent,
    EditAppointmentComponent,
    AppointmentEditFormComponent,
    AppointmentDetailDialogComponent,
    AppointmentNotificationLogComponent,
    AppointmentPatientMetaDataFormComponent,
  ]
})
export class XmedicalCalendarModule {}
